import { useSelector } from 'react-redux';
import {
  selectCategories,
  selectVideos,
  selectGroups,
  selectSocialCard,
} from '../../utils/redux/store/videos';

// Define a custom hook to encapsulate the Redux logic
export const useReduxVideos = () => {
  const videoCategories = useSelector(selectCategories);
  const videos = useSelector(selectVideos);
  const videoGroups = useSelector(selectGroups);
  const socialCard = useSelector(selectSocialCard);

  return { videoCategories, videos, videoGroups, socialCard };
};
